<template>
  <div>
    <list-header v-if="header" :icon="icon" :title="title" />

    <ul v-if="benefitsUsage.list.length" class="history">
      <li v-for="(event, index) in benefitsUsage.list" :key="index" md6 xs12 px-2>
        <history-item :event="event" />
      </li>
    </ul>

    <v-layout v-else>
      <v-flex px-2>Twoja historia jest pusta, zacznij używać karty u naszych partnerów.</v-flex>
    </v-layout>

    <v-flex v-if="showMore && benefitsUsage.list.length" md12 text-xs-right mt-2>
      <v-btn light depressed :to="moreTarget">
        <v-icon class="mr-1">{{ moreIcon }}</v-icon>

        <!-- Przycisk Więcej -->
        <slot name="more">
          <!-- Więcej -->
          Więcej
        </slot>
      </v-btn>
    </v-flex>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ListHeader from '@/components/ListHeader';
import HistoryItem from './HistoryItem';

/**
 * @vuese
 * Historia wykorzystanych usług
 * @group History
 */
export default {
  components: { ListHeader, HistoryItem },
  props: {
    // czy pokazywać nagłówek nad listą
    header: { type: Boolean, default: true },
    // ikona do wyświetlenia nad listą
    icon: { type: String, default: 'history' },
    // tytuł listy
    title: { type: String, required: true },
    // czy pokazywać slot więcej
    showMore: { type: Boolean, default: false },
    // ikona 'więcej'
    moreIcon: { type: String, default: 'history' },
    // obiekt route do przekazania dla przycisku więcej
    moreTarget: {
      type: Object,
      default: () => {
        return {
          name: 'history'
        };
      }
    }
  },

  computed: mapState({
    benefitsUsage: state => state.benefitsUsage
  })
};
</script>